import React from 'react';
import { Link } from 'react-router-dom';
import { CheckIcon, ArrowRightIcon } from 'lucide-react';
import { SEO } from '../../components/SEO';
export const AutoWrappenPage = () => {
  return <main data-id="element-819">
      <SEO title="Auto Wrappen Almere | Premium Car Wrapping | BKCustoms" description="Professioneel auto wrappen in Almere vanaf €1.250. Transformeer uw auto met premium vinyl wraps en bescherm de originele lak. BKCustoms auto styling service." canonical="/diensten/autowrappen" data-id="element-820" />
      {/* Header Banner */}
      <div className="relative bg-[#0a0a0a] py-28" data-id="element-821">
        <div className="absolute inset-0 overflow-hidden" data-id="element-822">
          <div className="absolute inset-0 bg-black/80 z-10" data-id="element-823"></div>
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/vPa5oULwHDcYzvNDCacQ1D/how-long-does-vinyl-wrap-last-1200x800-1-768x512.jpg" alt="Auto Wrappen in Almere" className="w-full h-full object-cover object-center" data-id="element-824" />
        </div>
        <div className="relative z-20 max-w-7xl mx-auto px-6 lg:px-8 text-center" data-id="element-825">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-826">
            <span className="text-[#D6281F]" data-id="element-827">Auto Wrappen Almere</span> -
            Transformeer uw auto
          </h1>
          <p className="text-white/80 max-w-2xl mx-auto text-lg" data-id="element-828">
            Professioneel auto wrappen in Almere. Transformeer uw auto met
            premium wraps en bescherm de originele lak met onze vakkundige
            wrapping service.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4 mt-8" data-id="element-829">
            <Link to="/afspraak-maken" className="bg-[#D6281F] hover:bg-[#D6281F]/90 text-white px-6 py-3 rounded-md transition-all duration-300 font-medium tracking-wide inline-flex items-center justify-center" data-id="element-830">
              <span className="mr-2" data-id="element-831">Direct afspraak maken</span>
              <ArrowRightIcon size={16} data-id="element-832" />
            </Link>
            <Link to="/contact" className="bg-white/5 hover:bg-white/10 text-white px-6 py-3 rounded-md transition-all duration-300 font-medium tracking-wide border border-white/10 inline-flex items-center justify-center" data-id="element-833">
              Offerte aanvragen
            </Link>
          </div>
        </div>
      </div>
      {/* Service Description Section */}
      <section className="bg-[#0a0a0a] py-20" data-id="element-834">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-835">
          <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16" data-id="element-836">
            {/* Image Section */}
            <div className="w-full lg:w-1/2" data-id="element-837">
              <div className="relative" data-id="element-838">
                <div className="absolute -inset-4 bg-gradient-to-tr from-[#D6281F] via-[#FF6B00] to-[#FFD500] opacity-30 blur-lg rounded-lg" data-id="element-839"></div>
                <div className="relative overflow-hidden rounded-lg border border-white/10 shadow-2xl" data-id="element-840">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/vPa5oULwHDcYzvNDCacQ1D/how-long-does-vinyl-wrap-last-1200x800-1-768x512.jpg" alt="Auto wrappen voorbeeld in Almere" className="w-full h-auto object-cover" data-id="element-841" />
                </div>
              </div>
            </div>
            {/* Content Section */}
            <div className="w-full lg:w-1/2" data-id="element-842">
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-843">
                Premium Car Wrapping in Almere
              </h2>
              <p className="text-white/80 text-lg mb-6 leading-relaxed" data-id="element-844">
                Bij BKCustoms in Almere bieden we professionele car wrapping
                diensten met hoogwaardige vinylfolies die uw auto een complete
                transformatie geven. Of u nu op zoek bent naar een
                kleurverandering, matte afwerking, of een uniek ontwerp, wij
                maken het mogelijk.
              </p>
              <p className="text-white/80 text-lg mb-8 leading-relaxed" data-id="element-845">
                Naast het esthetische aspect biedt een carwrap ook bescherming
                voor uw originele lak tegen steenslag, UV-straling en lichte
                krassen, waardoor de waarde van uw auto behouden blijft.
              </p>
              <div className="space-y-4 mb-8" data-id="element-846">
                <div className="flex items-center" data-id="element-847">
                  <div className="bg-[#D6281F]/20 rounded-full p-1 mr-3" data-id="element-848">
                    <CheckIcon size={14} className="text-[#D6281F]" data-id="element-849" />
                  </div>
                  <span className="text-white/90" data-id="element-850">
                    Premium vinylfolies met lange levensduur
                  </span>
                </div>
                <div className="flex items-center" data-id="element-851">
                  <div className="bg-[#D6281F]/20 rounded-full p-1 mr-3" data-id="element-852">
                    <CheckIcon size={14} className="text-[#D6281F]" data-id="element-853" />
                  </div>
                  <span className="text-white/90" data-id="element-854">
                    Bescherming van originele lak
                  </span>
                </div>
                <div className="flex items-center" data-id="element-855">
                  <div className="bg-[#D6281F]/20 rounded-full p-1 mr-3" data-id="element-856">
                    <CheckIcon size={14} className="text-[#D6281F]" data-id="element-857" />
                  </div>
                  <span className="text-white/90" data-id="element-858">
                    Uitgebreide kleur- en afwerkingsopties
                  </span>
                </div>
                <div className="flex items-center" data-id="element-859">
                  <div className="bg-[#D6281F]/20 rounded-full p-1 mr-3" data-id="element-860">
                    <CheckIcon size={14} className="text-[#D6281F]" data-id="element-861" />
                  </div>
                  <span className="text-white/90" data-id="element-862">
                    Professionele installatie door ervaren specialisten in
                    Almere
                  </span>
                </div>
              </div>
              <div className="flex flex-col sm:flex-row gap-4" data-id="element-863">
                <Link to="/afspraak-maken" className="bg-[#D6281F] hover:bg-[#D6281F]/90 text-white px-6 py-3 rounded-md transition-all duration-300 font-medium tracking-wide inline-flex items-center justify-center" data-id="element-864">
                  <span className="mr-2" data-id="element-865">Afspraak maken</span>
                  <ArrowRightIcon size={16} data-id="element-866" />
                </Link>
                <Link to="/contact" className="bg-white/5 hover:bg-white/10 text-white px-6 py-3 rounded-md transition-all duration-300 font-medium tracking-wide border border-white/10 inline-flex items-center justify-center" data-id="element-867">
                  Offerte aanvragen
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Options Section */}
      <section className="bg-[#0f0f0f] py-20" data-id="element-868">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-869">
          <div className="text-center mb-16" data-id="element-870">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-871">
              Onze <span className="text-[#D6281F]" data-id="element-872">Wrapping Opties</span> in
              Almere
            </h2>
            <p className="text-white/80 max-w-2xl mx-auto text-lg" data-id="element-873">
              Bij BKCustoms in Almere bieden we twee hoogwaardige wrapping
              oplossingen: Vinyl wrapping en PPF (Paint Protection Film).
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-874">
            <div className="bg-[#0a0a0a] border border-[#222] p-8 rounded-lg" data-id="element-875">
              <h3 className="text-xl font-bold text-white mb-4" data-id="element-876">
                Vinyl Wrapping
              </h3>
              <p className="text-white/80 mb-6" data-id="element-877">
                Vinyl wraps zijn perfect voor het veranderen van de kleur en
                uitstraling van uw auto. Beschikbaar in een breed scala aan
                kleuren en afwerkingen: glanzend, mat, satijn, metallic, chroom
                en zelfs kleurveranderende opties. Vinyl biedt een goede
                bescherming tegen lichte krassen en UV-straling, met een
                levensduur van 5-7 jaar bij goed onderhoud.
              </p>
              <ul className="space-y-2 mb-6" data-id="element-878">
                <li className="flex items-center text-white/80" data-id="element-879">
                  <CheckIcon size={14} className="text-[#D6281F] mr-2" data-id="element-880" />
                  Volledige kleurverandering
                </li>
                <li className="flex items-center text-white/80" data-id="element-881">
                  <CheckIcon size={14} className="text-[#D6281F] mr-2" data-id="element-882" />
                  Diverse afwerkingen (mat, glanzend, satijn)
                </li>
                <li className="flex items-center text-white/80" data-id="element-883">
                  <CheckIcon size={14} className="text-[#D6281F] mr-2" data-id="element-884" />
                  Gedeeltelijke wraps en accenten mogelijk
                </li>
                <li className="flex items-center text-white/80" data-id="element-885">
                  <CheckIcon size={14} className="text-[#D6281F] mr-2" data-id="element-886" />
                  Bescherming tegen lichte beschadigingen
                </li>
              </ul>
            </div>
            <div className="bg-[#0a0a0a] border border-[#222] p-8 rounded-lg" data-id="element-887">
              <h3 className="text-xl font-bold text-white mb-4" data-id="element-888">
                PPF (Paint Protection Film)
              </h3>
              <p className="text-white/80 mb-6" data-id="element-889">
                PPF is een transparante of licht getinte premium
                beschermingslaag die maximale bescherming biedt tegen steenslag,
                krassen, insecten en weersinvloeden. Deze zelfhelende film is
                dikker dan vinyl en speciaal ontworpen voor langdurige
                bescherming, met een levensduur tot 10 jaar. Ideaal voor het
                behoud van uw originele lak of als beschermlaag over vinyl
                wraps.
              </p>
              <ul className="space-y-2 mb-6" data-id="element-890">
                <li className="flex items-center text-white/80" data-id="element-891">
                  <CheckIcon size={14} className="text-[#D6281F] mr-2" data-id="element-892" />
                  Superieure bescherming tegen steenslag
                </li>
                <li className="flex items-center text-white/80" data-id="element-893">
                  <CheckIcon size={14} className="text-[#D6281F] mr-2" data-id="element-894" />
                  Zelfhelende eigenschappen
                </li>
                <li className="flex items-center text-white/80" data-id="element-895">
                  <CheckIcon size={14} className="text-[#D6281F] mr-2" data-id="element-896" />
                  Transparant of licht getint
                </li>
                <li className="flex items-center text-white/80" data-id="element-897">
                  <CheckIcon size={14} className="text-[#D6281F] mr-2" data-id="element-898" />
                  Langere levensduur dan vinyl
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      {/* Process Section */}
      <section className="bg-[#0a0a0a] py-20" data-id="element-899">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-900">
          <div className="text-center mb-16" data-id="element-901">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-902">
              Ons <span className="text-[#D6281F]" data-id="element-903">Proces</span> in Almere
            </h2>
            <p className="text-white/80 max-w-2xl mx-auto text-lg" data-id="element-904">
              Bij BKCustoms in Almere volgen we een zorgvuldig proces om de
              hoogste kwaliteit car wrapping te garanderen.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-905">
            <div className="bg-[#0a0a0a] border border-[#222] p-8 rounded-lg relative" data-id="element-906">
              <div className="absolute -top-4 -left-4 bg-[#D6281F] w-8 h-8 rounded-full flex items-center justify-center text-white font-bold" data-id="element-907">
                1
              </div>
              <h3 className="text-xl font-bold text-white mb-4 mt-2" data-id="element-908">
                Consultatie
              </h3>
              <p className="text-white/80" data-id="element-909">
                We bespreken uw wensen en adviseren over de beste opties voor uw
                voertuig, inclusief kleur, afwerking en materiaal.
              </p>
            </div>
            <div className="bg-[#0a0a0a] border border-[#222] p-8 rounded-lg relative" data-id="element-910">
              <div className="absolute -top-4 -left-4 bg-[#D6281F] w-8 h-8 rounded-full flex items-center justify-center text-white font-bold" data-id="element-911">
                2
              </div>
              <h3 className="text-xl font-bold text-white mb-4 mt-2" data-id="element-912">
                Voorbereiding
              </h3>
              <p className="text-white/80" data-id="element-913">
                Uw auto wordt grondig gereinigd en ontvet om een perfecte
                hechting van de vinylfolie te garanderen.
              </p>
            </div>
            <div className="bg-[#0a0a0a] border border-[#222] p-8 rounded-lg relative" data-id="element-914">
              <div className="absolute -top-4 -left-4 bg-[#D6281F] w-8 h-8 rounded-full flex items-center justify-center text-white font-bold" data-id="element-915">
                3
              </div>
              <h3 className="text-xl font-bold text-white mb-4 mt-2" data-id="element-916">
                Installatie
              </h3>
              <p className="text-white/80" data-id="element-917">
                Onze ervaren specialisten in Almere brengen de vinylfolie
                zorgvuldig aan, met aandacht voor elk detail en perfecte
                afwerking rond randen en hoeken.
              </p>
            </div>
            <div className="bg-[#0a0a0a] border border-[#222] p-8 rounded-lg relative" data-id="element-918">
              <div className="absolute -top-4 -left-4 bg-[#D6281F] w-8 h-8 rounded-full flex items-center justify-center text-white font-bold" data-id="element-919">
                4
              </div>
              <h3 className="text-xl font-bold text-white mb-4 mt-2" data-id="element-920">
                Afwerking
              </h3>
              <p className="text-white/80" data-id="element-921">
                Na installatie wordt uw auto geïnspecteerd op perfectie en
                ontvangt u advies over onderhoud om de levensduur van uw wrap te
                maximaliseren.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="bg-[#0a0a0a] py-16 border-t border-[#222]" data-id="element-922">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center" data-id="element-923">
          <h2 className="text-3xl font-bold text-white mb-6" data-id="element-924">
            Klaar voor een nieuwe look met auto wrappen in Almere?
          </h2>
          <p className="text-white/80 mb-8" data-id="element-925">
            Neem contact met ons op voor een persoonlijk advies of maak direct
            een afspraak voor jouw auto bij BKCustoms in Almere.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-926">
            <Link to="/afspraak-maken" className="bg-[#D6281F] hover:bg-[#D6281F]/90 text-white px-8 py-4 rounded-md transition-all duration-300 font-medium tracking-wide" data-id="element-927">
              Afspraak maken
            </Link>
            <Link to="/contact" className="bg-white/5 hover:bg-white/10 text-white px-8 py-4 rounded-md transition-all duration-300 font-medium tracking-wide border border-white/10" data-id="element-928">
              Contact opnemen
            </Link>
          </div>
        </div>
      </section>
    </main>;
};